
import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppComponentClass } from '../../../shared/service/AppComponent.class';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { MortgageService } from '../mortgage.service';
import { Comments, CommentsForm } from '../../../dialer/model/model.mortgage';
import { Theme } from '../../service/AutoTheme';

@Component({
  selector: 'dialer-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css']
})

export class CommentComponent extends AppComponentClass<Comments, CommentsForm> {
  private __data = new BehaviorSubject<Comments>(null);
  public solution= this.__data.asObservable();

  public form:FormGroup;
  private _sdata: { comments: string; };

  constructor(public data: MortgageService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, protected theme : Theme)
  {
    super(data, router, fb , msg); 
  }

  @Input() set commentsdata(v : Comments) {
    console.log("Current Comments Data :: ");
    console.log(v);
    this.__data.next(v);
  }

  ngOnInit() {   
    
    this.solution.subscribe(res=>{
      console.log(res);
      if(res==null)
      {
        this.cdata= new CommentsForm(null);
        this.form=this.cdata.makeform(this.fb);
      }
      else
      {
        this.cdata= new CommentsForm(res);
        this.form=this.cdata.makeform(this.fb);       
      }
    });
    // this.theme.Comments.subscribe((ress:any)=>{
    //   console.log(ress);
    //   console.log(this.cdata.comments);
    //   if(this.cdata.comments){

    //     this._sdata = {comments :this.cdata.comments  + "\n"     +  ress.comments}
    //   }else{
    //     this._sdata = {comments: ress.comments}
    //   }
    //   console.log(this._sdata);
      
    //   this.cdata= new CommentsForm(this._sdata);
    //   this.form=this.cdata.makeform(this.fb);     
    //   this.changeEvnt('comments');
    // })
  }  

  onSubmit()
  {
    if(this.cdata.saveForm(this.form))
      super.onSubmit();
  }

  warning()
  {
    if(this.cdata.comments != this.form.get("comments").value)
      this.cdata.comments = this.form.get("comments").value;
  }

  changeEvnt(key:string)
  { 
    console.log(key);
    if(key == 'comments')
      this.cdata.comments = this.form.get("comments").value;
    
    sessionStorage.setItem("comment", JSON.stringify(this.cdata));
    console.log("OnChange events called comment data : Key "+key+" Value :"+this.form.get(key).value);
    console.log(sessionStorage.getItem("comment"));

    this.theme.Getautosavedata(sessionStorage.getItem("comment"))
  }

}
